<template>
  <v-navigation-drawer width="30%" v-model="localDrawer" right temporary app>
    <v-list-item class="blue">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium white--text"
          >Histórico de aulas lançadas</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
    <v-list class="px-3" v-for="aula in aulas" :key="aula.id" dense>
      <v-card flat class="blue-grey lighten-5 pa-3 mb-4">
        <v-list-item-title class="text-left">
          <strong>Data da aula: </strong>
          <span>{{ aula?.data?.split("-").reverse().join("/") }}</span>
        </v-list-item-title>
      </v-card>

      <v-list-item-title
        v-if="isConteudoVazio(aula.conteudo_polivalencia)"
        class="font-weight-light subtitle-1 text-caption"
      >
        <p>
          <v-icon small class="mr-1 section-icon">mdi-format-list-bulleted</v-icon>
          <strong>Conteúdo: </strong>
        </p>
        <p>
          <span class="d-flex align-start mb-2 text-wrap">
            <ul>
              <li class="d-flex align-start mb-2 text-wrap">
                {{ aula.conteudos_atividades ? aula.conteudos_atividades : "- - -" }}
              </li>
            </ul>
          </span>
        </p>
      </v-list-item-title>

      <v-list-item-title v-else class="font-weight-light subtitle-1 text-caption">
        <v-icon small class="mr-1 section-icon">mdi-format-list-bulleted</v-icon>
        <strong>Conteúdos: </strong>
        <ul v-for="(item, index) in JSON.parse(aula.conteudo_polivalencia)" :key="index">
          <li class="d-flex align-start mb-2 text-wrap">{{ item }}</li>
        </ul>
      </v-list-item-title>

      <v-list-item-title>
        <p class="font-weight-light subtitle-1 text-caption">
          <v-icon small class="mr-1 section-icon">mdi mdi-table-cog</v-icon>

          <strong>Operações: </strong>
        </p>
      </v-list-item-title>
      <div v-if="aula.audits.length > 0">
        <v-list class="px-3" v-for="(audit, index) in aula.audits" :key="audit.id" dense>
          <v-list-item-title>
            <p class="font-weight-light subtitle-1 text-caption">
              Nome:
              <strong class="d-flex align-start mb-2 text-wrap">{{
                audit.username ? audit.username : "- - -"
              }}</strong>
            </p>
          </v-list-item-title>
          <v-list-item-title>
            <p class="font-weight-light subtitle-1 text-caption">
              Tipo de operação:
              <strong>{{ audit.event ? events[audit.event] : "- - -" }}</strong>
            </p>
          </v-list-item-title>
          <v-list-item-title>
            <p class="font-weight-light subtitle-1 text-caption">
              Data da operação:
              <strong>{{ audit.created_at ? dateFormat(audit.created_at) : "- - -" }}</strong>
            </p>
          </v-list-item-title>
          <v-divider v-if="index + 1 != aula.audits.length"></v-divider>
        </v-list>
      </div>
      <v-list-item-title v-else>
        <strong class="subtitle-1 text-caption">Operações não encontradas</strong>
      </v-list-item-title>

      <v-list-item-title>
        <v-list-item-content>
          <v-divider></v-divider>
        </v-list-item-content>
      </v-list-item-title>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { dateFormat } from "@/plugins/filters";

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    gestao_id: {
      type: Number,
      required: true,
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    async localDrawer() {
      this.$emit("input", this.localDrawer);
      if (this.localDrawer) {
        await this.carregarHistorico();
      }
    },
  },
  computed: {},
  data() {
    return {
      localDrawer: this.value,
      dialog: false,
      aulas: [],
      dateFormat,
      events: {
        created: "Criado",
        updated: "Atualizado",
        deleted: "Deletado",
        restored: "Restaurados",
      },
      masculino: "https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png",
      feminino:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbUqkRN4QaEzCW4brgWElc7lv8HdwP8RyxJ89WdDWAoIO-rEUIACXkEXG4n2mDGMLuz4Q&usqp=CAU",
    };
  },
  methods: {
    async carregarHistorico() {
      this.$loaderService.open("Carregando histórico");
      try {
        const response = await this.$services.gestoesDeAulasService.historicoAulasLancadas(
          this.gestao_id
        );

        this.aulas = response.historicoLancamento;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    isConteudoVazio(valor) {
      if (!valor) return true;
      if (Array.isArray(valor) && valor.length === 0) return true;
      if (typeof valor === "string" && valor.trim() === "[]") return true;
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-wrap {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto;
}
</style>
